import { PopoverOrigin } from '@mui/material'

export type PopoverPosition =
    | 'left'
    | 'right'
    | 'center'
    | 'top-left'
    | 'top-right'
    | 'top-center'

export function getMargin(position: PopoverPosition) {
    return position.startsWith('top') ? { marginBottom: 1 } : { marginTop: 1 }
}

type ArrowPositionReturn = {
    margin?: string
    bottom?: number | string
    top?: number | string
    left?: number | string
    right?: number | string
    transform?: string
}

export function getArrowPosition(
    position: PopoverPosition,
    element: HTMLElement | null,
): ArrowPositionReturn {
    if (!element) return {}

    const center = element.offsetWidth / 2 / 2

    switch (position) {
        case 'left':
            return {
                top: 0,
                left: center,
                transform: 'translate(-50%, -50%) rotate(315deg)',
            }
        case 'right':
            return {
                margin: '0 auto',
                top: 0,
                right: center,
                transform: 'translate(-50%, -50%) rotate(315deg)',
            }
        case 'center':
            return {
                margin: '0 auto',
                top: 0,
                left: '50%',
                transform: 'translate(-50%, -50%) rotate(315deg)',
            }
        case 'top-left':
            return {
                margin: '0 auto',
                bottom: 0,
                left: 0,
                transform: 'translate(0%, 46%) rotate(135deg)',
            }
        case 'top-right':
            return {
                margin: '0 auto',
                bottom: 0,
                right: center,
                transform: 'translate(0%, 40%) rotate(135deg)',
            }
        case 'top-center':
            return {
                margin: '0 auto',
                bottom: 0,
                left: '50%',
                transform: 'translate(0%, 46%) rotate(135deg)',
            }
    }
}

export function getAnchorOrigin(position: PopoverPosition): PopoverOrigin {
    switch (position) {
        case 'left':
            return { vertical: 'bottom', horizontal: 'left' }
        case 'right':
            return { vertical: 'bottom', horizontal: 'right' }
        case 'center':
            return { vertical: 'bottom', horizontal: 'center' }
        case 'top-left':
            return { vertical: 'top', horizontal: 'left' }
        case 'top-right':
            return { vertical: 'top', horizontal: 'right' }
        case 'top-center':
            return { vertical: 'top', horizontal: 'center' }
    }
}

export function getTransformOrigin(position: PopoverPosition): PopoverOrigin {
    switch (position) {
        case 'left':
            return { vertical: 'top', horizontal: 'left' }
        case 'right':
            return { vertical: 'top', horizontal: 'right' }
        case 'center':
            return { vertical: 'top', horizontal: 'center' }
        case 'top-left':
            return { vertical: 'bottom', horizontal: 'left' }
        case 'top-right':
            return { vertical: 'bottom', horizontal: 'right' }
        case 'top-center':
            return { vertical: 'bottom', horizontal: 'center' }
    }
}
